<style src='@/resources/styles/loading.css' scoped></style>

<template>
    <div class='spinner-container'>
        <div class='spinner'></div>
        <div class='rate'>{{ loadingProgress }}</div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'Spinner',
      computed: {
          ...mapGetters(['state', "loadingStatus", "loadingProgress", "filters"]),
      }
  }
</script>